import "react-toastify/dist/ReactToastify.css";
import { privateRoutes, publicRoutes } from "./routes";
import { useRoutes } from "react-router-dom";
import { env } from "config/env";
import { useAppSelector } from "store";

const AppRoutes = () => {
  const { accessToken } = useAppSelector(state => state.auth);
  const element = useRoutes(!accessToken ? publicRoutes : privateRoutes);

  return <div>{element}</div>;
};

export default AppRoutes;
